import React, { useEffect, useContext, useReducer } from 'react';
import reducer from '../reducers/wishlist_reducer';
import {
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  CLEAR_WISHLIST,
} from '../actions';

const getLocalStorage = () => {
  let wishlist = localStorage.getItem('wishlist');
  if (wishlist) {
    return JSON.parse(wishlist);
  } else {
    return [];
  }
};

const initialState = {
  wishlist: getLocalStorage(),
};

const WishlistContext = React.createContext();

export const WishlistProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addToWishlist = (product) => {
    dispatch({
      type: ADD_TO_WISHLIST,
      payload: { product },
    });
  };

  const removeFromWishlist = (productId) => {
    dispatch({ type: REMOVE_FROM_WISHLIST, payload: { productId } });
  };

  const clearWishlist = () => {
    dispatch({ type: CLEAR_WISHLIST });
  };

  const isInWishlist = (productId) => {
    return state.wishlist.some((item) => item._id === productId);
  };

  useEffect(() => {
    localStorage.setItem('wishlist', JSON.stringify(state.wishlist));
  }, [state.wishlist]);

  return (
    <WishlistContext.Provider
      value={{
        ...state,
        addToWishlist,
        removeFromWishlist,
        clearWishlist,
        isInWishlist,
      }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlistContext = () => {
  return useContext(WishlistContext);
};
